// Utils
import registerLine from '../../../common/lines/index';

// Components
import presentationalComponent from './LinePresentationalWrapper';
import containerComponent from './LineContainer';

// Constants
import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerLine({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.COLOR, TOOLS.START_ARROW, TOOLS.END_ARROW, TOOLS.LINE_LABEL, TOOLS.LINE_STYLE, TOOLS.LINE_WEIGHT],
    });
